import { windowWidth, windowHeight } from "../layout";
// gsap
import { gsap } from "../layout";
// fancyapps
import { Fancybox } from "@fancyapps/ui";

function galleryPhoto() {
    Fancybox.bind('[data-fancybox="gallery-photo"]', {
        Thumbs: false,
        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ["close"],
            },
        },
    });
}

document.addEventListener("DOMContentLoaded", function () {
    galleryPhoto();
})

window.addEventListener('resize', () => {
})